<div class="dropdown w-100" [ngClass]=" ddlClassName != '' ? ddlClassName : 'position-relative'">
    <button class="btn btn-block text-left dropdown-toggle form-select form-select-custom border-custom pr-30 overflow-hidden {{className}}" type="button" data-bs-toggle="dropdown" aria-haspopup="true"
        data-display="static" [title]="selectedName" [id]="id"
        [ngClass]="{ 'border border-danger': showError }">
        <span [style.font-size]="fontSize" [style.color]="fontColor" class="d-block overflow-hidden">
            {{selected ? selected : (placeholder ? placeholder : 'Select')}}
        </span>
    </button>
    <div class="dropdown-menu {{ddlMenuClassName}}">
        <!-- search -->
        <div *ngIf="showSearch" class="dropdown-item dropdown-item-search" onclick="event.stopPropagation();">
            <div class="input-group">
                <input type="text" class="form-control" [style.font-size]="fontSize" [style.color]="fontColor" placeholder="Search" [(ngModel)]="search">
                <!-- [(ngModel)]="search"  -->
                <!-- <div class="input-group-append">
                    <span class="input-group-text h-100">
                        <img src="/assets/icons/search.svg" alt="" title="Bootstrap">
                    </span>
                </div> -->
            </div>
        </div>

        <!-- checkboxes -->
        <div class="dropdown-item-checkboxes">
            <!-- all -->
            <div class="dropdown-item" onclick="event.stopPropagation();" *ngIf="showAll && all.visible"
                [ngClass]="{ 'checked': all.checked }">
                <!-- checkbox -->
                <div class="custom-control custom-checkbox">
                    <input type="checkbox" class="custom-control-input" [id]="'chkItem_'+ id +'_' + all.id"
                        (change)='onChange($event, all)' [checked]="all.checked" [disabled]="isReadOnly">
                    <label class="custom-control-label" [for]="'chkItem_'+ id +'_' + all.id" [style.font-size]="fontSize" [style.color]="fontColor">
                        <span class="pl-2" [title]="all.name">{{all.name}}</span>
                    </label>
                </div>
            </div>

            <ng-container *ngFor="let item of filtered; let i = index; trackBy: trackByUuid">
                <div class="dropdown-item w-100" onclick="event.stopPropagation();" *ngIf="item.visible"
                    [ngClass]="{ 'checked': item.checked }">
                    <!-- checkbox -->
                    <div class="custom-control custom-checkbox">
                        <input type="checkbox" class="custom-control-input" [id]="'chkItem_'+ id +'_' + item.id"  (click)="onItemClick($event, item)"
                            (change)='onChange($event, item)' [checked]="item.checked" [disabled]="isReadOnly">
                        <label class="custom-control-label" [for]="'chkItem_' + id + '_' + item.id" [style.font-size]="fontSize" [style.color]="fontColor">
                            <span class="pl-2" [title]="item.name">
                                {{item.name}}
                                {{(supportingText == true && (item.name1??'' != '')? ' (' + item.name1 + ')' :'' )}}
                            </span>
                        </label>
                    </div>
                </div>
            </ng-container>
        </div>

        <!-- not found -->
        <div class="dropdown-item" *ngIf="isEmpty" [style.font-size]="fontSize" [style.color]="fontColor">
            <!-- No item found  -->
        </div>

        <!-- status -->
        <div *ngIf="showStatus" class="dropdown-count text-dark">
            <span [style.font-size]="fontSize" [style.color]="fontColor"><b>Count:</b> {{_items.length}}</span>
            <span [style.font-size]="fontSize" [style.color]="fontColor"><b>Checked:</b> {{checked}}</span>
            <span [style.font-size]="fontSize" [style.color]="fontColor" *ngIf="search"><b>Search Count:</b> {{filtered.length}}</span>
        </div>
    </div>
</div>